import { EVENT_CLOSE } from "manifest-bridge-core/src/events";

import { ClientTransferStatus, TransferData } from "../typings";
import { resetSentryUser } from "../lib/sentry";
import generateURIRedirect from "./generateURIrefirect";
import Analytics from "./productAnalytics";

export type CloseParams = {
  transferIntentStatus: ClientTransferStatus;
  transferData: TransferData;
};

const sendClose = (data: CloseParams, isWebview: boolean, origin: string) => {
  resetSentryUser();
  if (isWebview) {
    // create redirect uri
    const redirectURI = generateURIRedirect({ event: EVENT_CLOSE, closeData: data });
    window.location.href = redirectURI;
  } else {
    window.sessionStorage.clear();
    if (data) {
      const { transferIntentStatus } = data;
      Analytics.track({
        name: "Exited Bridge",
        properties: {
          transferIntentStatus,
        },
      });
    }

    window.parent.postMessage(
      {
        type: EVENT_CLOSE,
        data,
      },
      origin,
    );
  }
};

export default sendClose;
